import { ErrorLayout } from 'components';
import { useTranslation } from 'libs/i18n';

export const NotFound = () => {
  const { t } = useTranslation();

  return <ErrorLayout subtitle={t('notFound.subtitle')} />;
};
